import React from "react";
import { FaInstagram } from "react-icons/fa";
import styles from "./index.module.css";

const InstagramLink = ({ size = 14 }) => {
    return (
        <a
            href="https://www.instagram.com/lo.lo.tour/"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.instaLink}
        >
            <span className={styles.instaIcon}>
                <FaInstagram size={size} color="#ffffff" />
                <span className={styles.instaText}>인스타그램</span>
            </span>
        </a>
    );
};

export default InstagramLink;
